module.exports = __webpack_public_path__ + "static/img/img35.b0611e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ychy/img35.jpg
// module id = 9ERY
// module chunks = 1